"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _PageConstants = require("./PageConstants");

var _UIAbstractPageTemplate = _interopRequireDefault(require("./UIAbstractPageTemplate"));

function UIDashboardPage(props) {
  return _react.default.createElement(_UIAbstractPageTemplate.default, (0, _extends2.default)({}, props, {
    horizontalDivider: true,
    mainSectionBackgroundColor: _PageConstants.CARD_BACKGROUND
  }));
}

UIDashboardPage.propTypes = (0, _omit.default)(_UIAbstractPageTemplate.default.propTypes, 'horizontalDivider', 'mainSectionBackgroundColor');
UIDashboardPage.defaultProps = (0, _omit.default)(_UIAbstractPageTemplate.default.defaultProps, 'horizontalDivider', 'mainSectionBackgroundColor');
UIDashboardPage.displayName = 'UIDashboardPage';
var _default = UIDashboardPage;
exports.default = _default;
module.exports = exports.default;